import { Link, useNavigate, useParams } from "react-router-dom";
import BusinessPlanLeftTab from "./BusinessPlanLeftTab";
import { API_URL, URLS } from "../../_config";
import React, { useEffect, useState } from "react";
import Nav from "../../components/layouts/nav";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Error from "../../components/formFieldError";
import FormTexAreatInput from "../../_common/form-elements/textareaInput";
import { replaceUrlParams } from "../../_common/functions";
import Footer from "../../components/layouts/footer";
import { useSelectedCountry, useToken, useUser } from "../../_common/hooks/authHook";
import './AIBtn.scss';
import Select from "react-select";
import AIAssistanceAnsRight from "./AIAssistanceAnsRight";
import HelpPanelRight from "./HelpPanelRight";

const BusinessPlan = () => {
    const selectedCountry: any = useSelectedCountry();
    const [questionnaire, setQuestionnaire] = useState<any>(null);
    const [currentActiveTab, setCurrentActiveTab] = useState<any>(0);
    const [addonsIds, setAddonsIds] = useState<any>(null);
    const [proposalId, setProposalId] = useState<any>(null);
    const [userId, setUserId] = useState<any>(null);
    const [myBusinessPlan, setMyBusinessPlan] = useState<any>(null);
    const [aiBtnDisable, setAiBtnDisable] = useState<any>(false);
    const [aiBtnDisableId, setAiBtnDisableId] = useState<any>(0);


    let tokenData: any = useToken('business-plan');
    let userData: any = useUser();

    const navigate: any = useNavigate();
    const urlParams: any = useParams();
    const subscriptionId = urlParams?.subscriptionId;

    const queryParams = new URLSearchParams(window.location.search);
    const subsId = queryParams.get("sId");
    const _addonsIds = queryParams.get("addons");
    const _proId = queryParams.get("pId");
    const isEmbed = queryParams.get("embed") === "true";

    const [existingFiles, setExistingFiles] = useState<any>({});
    const [showAiAns, setShowAiAns] = useState<any>(null);
    const [AIDataRight, setAIDataRight] = useState<any>({});
    const [showHelp, setShowHelp] = useState<any>(null);
    const [helpDataRight, setHelpDataRight] = useState<any>({});
    const { control, formState: { errors }, handleSubmit, setError, register, reset, setValue, getValues, clearErrors } = useForm();

    // ---- Document upload questions (multiple files) ----
    const MAX_FILES_PER_QUESTION = 10;
    const MAX_FILE_MB = 20;
    // Field value: File[] (new files picked), 'existing_file' (only earlier files kept) or null (nothing).
    const fileFieldValue = (newFiles: File[], keptCount: number) =>
        newFiles.length > 0 ? newFiles : (keptCount > 0 ? 'existing_file' : null);

    const addFilesToQuestion = (questionId: any, picked: FileList | null, currentValue: any, onChange: (v: any) => void) => {
        if (!picked || picked.length === 0) return;
        const current: File[] = Array.isArray(currentValue) ? currentValue : [];
        const kept = (existingFiles?.[questionId] || []).length;
        const merged = [...current];
        const rejected: string[] = [];
        Array.from(picked).forEach((f) => {
            if (f.size > MAX_FILE_MB * 1024 * 1024) { rejected.push(`${f.name} is larger than ${MAX_FILE_MB}MB`); return; }
            if (merged.some((m) => m.name === f.name && m.size === f.size)) return; // same file picked twice
            merged.push(f);
        });
        if (kept + merged.length > MAX_FILES_PER_QUESTION) {
            rejected.push(`You can upload up to ${MAX_FILES_PER_QUESTION} files for this question`);
            merged.splice(Math.max(0, MAX_FILES_PER_QUESTION - kept));
        }
        if (rejected.length) {
            setError(`question_${questionId}`, { type: 'manual', message: rejected.join('. ') });
        } else {
            clearErrors(`question_${questionId}`);
        }
        onChange(fileFieldValue(merged, kept));
    };

    const removeNewFile = (questionId: any, index: number, currentValue: any, onChange: (v: any) => void) => {
        const current: File[] = Array.isArray(currentValue) ? [...currentValue] : [];
        current.splice(index, 1);
        onChange(fileFieldValue(current, (existingFiles?.[questionId] || []).length));
    };

    const removeExistingFile = (questionId: any, fileId: any, currentValue: any, onChange: (v: any) => void) => {
        const remaining = (existingFiles?.[questionId] || []).filter((f: any) => f?.id !== fileId);
        setExistingFiles((prev: any) => ({ ...prev, [questionId]: remaining }));
        onChange(fileFieldValue(Array.isArray(currentValue) ? currentValue : [], remaining.length));
    };

    console.log('errors===', errors);

    const getQuestionnaire = async () => {
        try {
            const response = await fetch(API_URL.BUSINESS_PLAN.QUESTIONNAIRE + "/" + subscriptionId + "?addon=" + _addonsIds);
            const resp = await response.json();
            setQuestionnaire(resp.data)

            resp.data && resp.data.map((questionnaireItem: any, tabIndex: number) => {
                let resetData: any = {};
                questionnaireItem?.questions?.map((question: any) => {

                    const eq_userField = question?.question_in_questionnaire_step?.eq_user_detail_field;
                    if (tokenData && userData) {
                        if (eq_userField) {
                            if (eq_userField == 'full_name') {
                                setValue(`question_${question.id}`, userData?.full_name);
                            } else if (eq_userField == 'email') {
                                setValue(`question_${question.id}`, userData?.email);
                            } else if (eq_userField == 'first_name') {
                                setValue(`question_${question.id}`, userData?.first_name);
                            } else if (eq_userField == 'last_name') {
                                setValue(`question_${question.id}`, userData?.last_name);
                            } else if (eq_userField == 'phone') {
                                setValue(`question_${question.id}`, userData?.phone);
                            } else if (eq_userField == 'job_title') {
                                setValue(`question_${question.id}`, userData?.job_title);
                            } else if (eq_userField == 'department') {
                                setValue(`question_${question.id}`, userData?.department);
                            }
                        }
                    }
                })
            })
        } catch (error) {
            console.log('Error occurred while making the API request.');
            // Handle error
            setQuestionnaire([])
        }
    };


    const getMyBusinessPlanDetails = async () => {
        try {
            const response = await fetch(API_URL.ACCOUNT.MY_BUSINESS_PLAN_DETAILS + "/" + _proId, {
                headers: { Authorization: `Bearer ${tokenData}` }
            });
            const resp = await response.json();
            // console.log('resp.data.answers===============', resp.data.answers);
            setMyBusinessPlan(resp.data)
            setUserId(resp.data?.user_id);
            let resetValues: any = {}
            let filesMap: any = {};
            resp.data?.answers && resp.data?.answers?.map((item: any) => {
                const _attachments = (item?.answer_attachments?.length > 0)
                    ? item.answer_attachments
                    : (item?.answer_attachment ? [item.answer_attachment] : []);
                if (_attachments.length > 0) {
                    filesMap[item?.question_id] = _attachments;
                    resetValues[`question_${item?.question_id}`] = 'existing_file';
                } else if (item?.options?.length > 0) {
                    let _optionItemIds: any = [];
                    item?.options?.map((_optionItem: any, _index: any) => {
                        _optionItemIds.push(_optionItem?.option_id);
                        // resetValues[`question_${item?.question_id}[option][${_index}]`] = _optionItem?.option_id;
                        // resetValues[`question_${_optionItem?.option?.question_id}[option]`] = _optionItem?.option_id;
                    })
                    resetValues[`question_${item?.question_id}[option]`] = _optionItemIds;
                } else {
                    resetValues[`question_${item?.question_id}`] = item?.answer_text;
                }
            })
            // console.log('resetValues===', resetValues);
            setExistingFiles(filesMap);
            reset(resetValues);
        } catch (error) {
            console.log('Error occurred while making the API request.', error); // Handle error
            setMyBusinessPlan([])
        }
    }

    useEffect(() => {
        setAddonsIds(_addonsIds);
        getQuestionnaire();
        if (_proId) {
            setProposalId(_proId);
            getMyBusinessPlanDetails();
        }
    }, [])

    const handleTabClick = (_tabIndex: any) => {
        clearErrors();
        setCurrentActiveTab(_tabIndex)
    }


    const saveProposal = (answers: any) => {
        return new Promise((resolve, reject) => {
            let params: any = {
                "country": selectedCountry?.id,
                "subscription_plan_id": subscriptionId,
                "questionnaire_step_id": questionnaire[currentActiveTab]?.id,
                "answers": answers,
                "addons": addonsIds ? addonsIds.split(",") : [],
            }
            if (currentActiveTab === 0 && !proposalId) {
                const cookieMatch = document.cookie.match(/(?:^|;\s*)affiliate_ref=([^;]*)/);
                if (cookieMatch) {
                    params.affiliate_ref = decodeURIComponent(cookieMatch[1]);
                }
            }
            if (currentActiveTab > 0 || (userId && proposalId)) {
                params.proposal_id = proposalId;
                params.user_id = userId;
            }

            const hasNewFiles = answers.some((answer: any) => answer?._files?.length > 0);

            let fetchOptions: any;
            if (hasNewFiles) {
                const formData = new FormData();
                formData.append('country', params.country ?? '');
                formData.append('subscription_plan_id', params.subscription_plan_id ?? '');
                formData.append('questionnaire_step_id', params.questionnaire_step_id ?? '');
                if (params.proposal_id) formData.append('proposal_id', params.proposal_id);
                if (params.user_id) formData.append('user_id', params.user_id);
                (params.addons || []).forEach((addonId: any) => formData.append('addons[]', addonId));

                answers.forEach((answer: any, idx: number) => {
                    formData.append(`answers[${idx}][question_id]`, answer.question_id);
                    formData.append(`answers[${idx}][answer_text]`, answer.answer_text ?? '');
                    (answer.answer_options || []).forEach((optionId: any) => {
                        formData.append(`answers[${idx}][answer_options][]`, optionId);
                    });
                    (answer._files || []).forEach((f: File) => {
                        formData.append(`answers[${idx}][answer_files][]`, f);
                    });
                    if (answer.keep_file_ids_present) {
                        formData.append(`answers[${idx}][keep_file_ids_present]`, '1');
                        (answer.keep_file_ids || []).forEach((id: any) => formData.append(`answers[${idx}][keep_file_ids][]`, id));
                    }
                });

                fetchOptions = { method: 'POST', body: formData };
            } else {
                // File objects can't go in JSON; drop the (empty) _files list
                const jsonParams = { ...params, answers: answers.map(({ _files, ...rest }: any) => rest) };
                fetchOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(jsonParams),
                };
            }
            
            fetch((proposalId) ? API_URL.BUSINESS_PLAN.PROPOSAL_UPDATE : API_URL.BUSINESS_PLAN.PROPOSAL_CREATE, fetchOptions)
                .then(response => response.json())
                .then(resp => {
                    if (resp?.status == 200) {
                        // Handle success 
                        setUserId(resp?.data?.user?.id);
                        setProposalId(resp?.data?.proposal?.id);
                        resolve(resp.message);
                        // Delete affiliate_ref session cookie after successful registration
                        document.cookie = 'affiliate_ref=; path=/; max-age=0; SameSite=Lax';
                    } else {
                        const errorResp = resp?.data;
                        if (errorResp && errorResp.hasOwnProperty('email')) {
                            const emailQuestion = questionnaire?.[currentActiveTab]?.questions?.find(
                                (q: any) => q?.question_in_questionnaire_step?.eq_user_detail_field === 'email'
                            );
                            if (emailQuestion) {
                                setError(`question_${emailQuestion.id}`, {
                                    type: 'manual',
                                    message: errorResp['email'][0]
                                });
                            }
                            reject(errorResp['email'][0]);
                        } else {
                            reject(resp.message);
                            if (errorResp) {
                                Object.keys(errorResp).map((key) => {
                                    setError(`question_${key}`, {
                                        type: "manual",
                                        message: errorResp[key]
                                    })
                                })
                            }
                        }
                    }
                })
                .catch(error => {
                    // Handle error
                    console.error('Error:', error);
                    reject(error.message);
                });
        })
    }


    const saveFormHandler = async (data: any) => {
        questionnaire?.map((item: any, tabIndex: number) => {
            if (tabIndex == currentActiveTab) {
                let error: boolean = false;
                let params: any = []

                item?.questions?.map((question: any) => {
                    if (errors[`question_${question?.id}`]) {
                        error = true;
                    } else if (question?.question_type?.type_name === 'file_upload') {
                        const fieldValue = data[`question_${question?.id}`];
                        const answerEntry: any = {
                            "question_id": question?.id,
                            "answer_text": "",
                            "answer_options": [],
                        };
                        // File[] = new files picked this time. Earlier uploads still shown on the
                        // form are sent as keep_file_ids; any the user removed are left out.
                        if (Array.isArray(fieldValue)) {
                            answerEntry._files = fieldValue.filter((f: any) => f instanceof File);
                        }
                        answerEntry.keep_file_ids = (existingFiles?.[question?.id] || []).map((f: any) => f?.id).filter((id: any) => !!id);
                        answerEntry.keep_file_ids_present = 1;
                        params.push(answerEntry);
                    } else {
                        if (data[`question_${question?.id}`]?.option !== undefined) {
                            params.push({
                                "question_id": question?.id,
                                "answer_text": "",
                                "answer_options": data[`question_${question?.id}`]?.option ? [data[`question_${question?.id}`]?.option] : [],
                            })
                        } else {
                            params.push({
                                "question_id": question?.id,
                                "answer_text": (typeof data[`question_${question?.id}`] == "string") ? data[`question_${question?.id}`] : "",
                                "answer_options": (typeof data[`question_${question?.id}`] == "string") ? [] : data[`question_${question?.id}`],
                            })
                        }
                    }
                })

                if (!error) {
                    toast.promise(
                        saveProposal(params), {
                        loading: 'Updating...',
                        success: (msg: any) => {
                            if (currentActiveTab == 0 && userId && proposalId) {
                                navigate(replaceUrlParams(URLS.BUSINESS_PLAN, { subscriptionId: subscriptionId }) + "?addons=" + addonsIds
                                    + "&pId=" + proposalId + "&uId=" + userId);
                            }
                            if (currentActiveTab == questionnaire.length - 1) {
                                if(!tokenData) {
                                    navigate(URLS.THANKYOU_PAGE, { state: { fromSubmission: true } });
                                }else {
                                    navigate(URLS.THANKYOU_PAGE, { state: { fromSubmission: true } });
                                }
                            } else {
                                setCurrentActiveTab(currentActiveTab + 1)
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                            return <b>{msg}</b>
                        },
                        error: (msg: any) => { return <b>{msg}</b> },
                    });
                } else {
                    console.log('error=------------------', errors);
                }
            }
        })
    }

    const getRequiredStart = (data: any) => {
        const dataObjArr = data && JSON.parse(data);
        let star: boolean = false;

        // console.log('dataObjArr====', dataObjArr);
        // if (Array.isArray(dataObjArr)) {
        //     dataObjArr&&  dataObjArr.forEach((item: any) => {
        //     if (item.required) {
        //         star = true;
        //     }
        //     });
        // }

        dataObjArr && Object.entries(dataObjArr).map((value: any) => {
            if (Array.isArray(value)) {
                value && value.forEach((item: any) => {
                    if (item.required) {
                        star = true;
                    }
                });
            }
        })
        return (star) ? '*' : '';
    }

    const getFieldValidations = (data: any, questionText: string, questionId?: any) => {
        const dataObjArr = data && JSON.parse(data);
        const dataObj = dataObjArr && dataObjArr[0];
        // console.log('dataObj====', questionText, dataObj);
        let returnValidation: any = {};

        dataObjArr && Object.entries(dataObjArr).map((value: any) => {
            if (Array.isArray(value)) {
                value && value.forEach((dataObj: any) => {
                    if (dataObj && dataObj.required) {
                        returnValidation.required = dataObj.required?.message
                    }
                    if (dataObj && dataObj.max) {
                        returnValidation.maxLength = { value: dataObj.max?.value, message: dataObj.max?.message }
                    }
                    if (dataObj && dataObj.min) {
                        returnValidation.minLength = { value: dataObj.min?.value, message: dataObj.min?.message }
                    }
                    if (dataObj && dataObj.minValue) {
                        returnValidation.min = { value: dataObj.minValue?.value, message: dataObj.minValue?.message }
                    }
                    if (dataObj && dataObj.maxValue) {
                        returnValidation.max = { value: dataObj.maxValue?.value, message: dataObj.maxValue?.message }
                    }
                    if (dataObj && dataObj.email) {
                        returnValidation.pattern = { value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: dataObj.email?.message }
                    }
                });
            }
        })

        // if (dataObj && dataObj.numeric) {
        //     returnValidation.pattern = { value: /^[0-9]*$/, message: dataObj.numeric?.message }
        // }
        // if (dataObj && dataObj.integer) {
        //     returnValidation.pattern = { value: /^[0-9]*$/, message: dataObj.integer?.message }
        // }
        // if (dataObj && dataObj.string) {
        //     returnValidation.pattern = { value: /^[a-zA-Z]*$/, message: dataObj.string?.message }
        // } 

        return returnValidation
    }

    const getAIRecommendations = (question_id: any, question_text: string) => {
        setShowAiAns(true);
        setAIDataRight({ question_id: question_id, question_text: question_text });
        // window.open(URLS.AI_ASSISTANCE_ANS + "?qId=" + question_id + "&q=" + question_text, 'blank');
        // setAiBtnDisable(true);
        // setAiBtnDisableId(question_id);
        // try {
        //     const response = await fetch(API_URL.BUSINESS_PLAN.AI_SUGGESTION + "?question_id=" + question_id, {
        //         headers: { Authorization: `Bearer ${tokenData}` }
        //     });
        //     const resp = await response.json(); // Get the JSON response
        //     if (resp?.suggestion) {
        //         toast.success('AI recommendation received.');
        //         window.open(URLS.AI_ASSISTANCE_ANS, '_blank');
        //     } else {
        //         toast.error('No AI recommendation available.');
        //     }
        //     setValue(`question_${question_id}`, resp?.suggestion);
        //     setAiBtnDisableId(0);
        // } catch (error) {
        //     setAiBtnDisableId(0);
        //     console.log('Error occurred while making the API request.', error); // Handle error 
        // }
    }

    useEffect(() => {
        if (aiBtnDisable) {
            setTimeout(() => {
                setAiBtnDisable(false);
            }, 5000);
        }
    }, [aiBtnDisable])


    const handleClose = () => setShowAiAns(null);
    const handleHelpClose = () => setShowHelp(null);

    const getHelp = (help_text: any, title?: string) => {
        setHelpDataRight({ help_text, title });
        setShowHelp(true);
    }

    const AI_BTN = (question: any) => {
        // If help text is provided for a question, render a Help button that opens the Help panel
        if (question?.help_text || question?.question_in_questionnaire_step?.help_text) {
            const helpText = question?.question_in_questionnaire_step?.help_text || question?.help_text;
            return <>
                <div className="btn-wrap-bp justify-content-end">
                    <button type="button" className="solid-btn get_ai_recommendations mt-2"
                        onClick={() => getHelp(helpText, question?.question_text)}>
                        Help
                    </button>
                </div>
            </>
        }
        return '';
        // return <>
        //     {
        //         question?.prompt != null && <div className="btn-wrap-bp justify-content-end">
        //             <button type="button" className="solid-btn get_ai_recommendations mt-2"
        //                 id={`AI_btnId__${question?.id}`} onClick={() => getAIRecommendations(question?.id, question?.question_text)}
        //                 disabled={aiBtnDisable}>
        //                 {(aiBtnDisableId == question?.id) ? 'Generating AI Assistance...' : 'AI Assistance'}
        //             </button>
        //         </div>
        //     }
        // </>
    }

    return (
        <>
            {!isEmbed && <Nav />}
            <div className={`body-part bp-wrap ${!isEmbed ? 'gray-bg mt-105' : ''}`}>
                <BusinessPlanLeftTab questionnaire={questionnaire} currentActiveTab={currentActiveTab} handleTabClick={handleTabClick} />
                {
                    questionnaire?.map((item: any, tabIndex: number) => {
                        // <>{console.log(item)}</>
                        if (tabIndex == currentActiveTab) {
                            return (
                                <div className={`main-part-bp `} key={`questionSection_${item.id}`}>
                                    <form onSubmit={handleSubmit(saveFormHandler)}>
                                        {tabIndex === 0 && item?.subscription_plan?.title && (
                                            <h2 className="bp-plan-name text-center">{item.subscription_plan.title}</h2>
                                        )}
                                        <h2 className="page-title text-center mb-5">
                                            {item?.title.split(" ").map((word: string, i: number) => (
                                                i === 0 ? <React.Fragment key={`questionSection_${i + word}`}>{word} </React.Fragment> : <span key={`questionSection_${i + word}`}>{word} </span>
                                            ))}
                                        </h2>
                                        {/* <p className="tag-line text-center mb-5">{item?.description} </p> */}
                                        <Controller
                                            defaultValue={item?.id}
                                            control={control}
                                            name={`questionnaire_step_id[${tabIndex}]`}
                                            render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                <input type="hidden" name={name} onChange={onChange} value={value} />
                                            )}
                                        />

                                        <div className="white-box-wrap mb-3">
                                            {item?.questions.length > 0 ? item?.questions?.map((question: any) => {
                                                if (['input_text', 'email', 'date', 'phone'].indexOf(question?.question_type?.type_name) >= 0) {
                                                    let inputType = 'text';
                                                    // if (question?.question_type?.type_name === 'email') {
                                                    //     inputType = 'email';
                                                    // } else 
                                                    if (question?.question_type?.type_name === 'number') {
                                                        inputType = 'number';
                                                    } else if (question?.question_type?.type_name === 'date') {
                                                        inputType = 'date';
                                                    }
                                                    return <div key={`input_text${question.question_text}`} className="mb-3 float-input">
                                                        <label className="form-label">{question.question_text} <span>{getRequiredStart(question?.question_in_questionnaire_step?.validations)}</span></label>
                                                        <Controller
                                                            defaultValue={""}
                                                            control={control}
                                                            name={`question_${question?.id}`}
                                                            rules={getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text, question?.id)}

                                                            render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                                <input type={inputType} name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Enter..." spellCheck="false" data-ms-editor="true" />
                                                            )}

                                                        />

                                                        <Error error={errors[`question_${question?.id}`]} customClass="text-xs" />
                                                        {AI_BTN(question)}
                                                        {/* {
                                                            question?.prompt != null && <div className="btn-wrap-bp justify-content-end">
                                                                <button type="button" className="solid-btn get_ai_recommendations mt-2  "
                                                                    id={`AI_btnId__${question?.id}`} onClick={() => getAIRecommendations(question?.id, question?.question_text)}
                                                                    disabled={aiBtnDisable}>
                                                                    {(aiBtnDisableId == question?.id) ? 'Generating AI Assistance...' : 'AI Assistance'}
                                                                </button>
                                                            </div>
                                                        } */}
                                                    </div>
                                                } else if (question?.question_type?.type_name === 'file_upload') {
                                                    const keptFiles: any[] = existingFiles?.[question?.id] || [];
                                                    return <div key={`file_upload_${question.question_text}`} className="mb-3 float-input">
                                                        <label className="form-label">{question.question_text} <span>{getRequiredStart(question?.question_in_questionnaire_step?.validations)}</span></label>
                                                        <Controller
                                                            defaultValue={null}
                                                            control={control}
                                                            name={`question_${question?.id}`}
                                                            rules={getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text)}
                                                            render={({ field: { onChange, onBlur, value, name, ref } }) => {
                                                                const newFiles: File[] = Array.isArray(value) ? value : [];
                                                                const total = keptFiles.length + newFiles.length;
                                                                return <>
                                                                    <input
                                                                        type="file"
                                                                        multiple
                                                                        name={name}
                                                                        ref={ref}
                                                                        onBlur={onBlur}
                                                                        className="form-control"
                                                                        accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.gif,.webp"
                                                                        disabled={total >= MAX_FILES_PER_QUESTION}
                                                                        onChange={(e) => {
                                                                            addFilesToQuestion(question?.id, e.target.files, value, onChange);
                                                                            e.target.value = ''; // allow picking more files (or the same one again)
                                                                        }}
                                                                    />
                                                                    <em>Accepted formats: Word, Excel, PDF, or image. Max {MAX_FILE_MB}MB per file, up to {MAX_FILES_PER_QUESTION} files. You can select several files at once.</em>
                                                                    {total > 0 && (
                                                                        <ul className="list-unstyled mt-2 mb-0">
                                                                            {keptFiles.map((f: any) => (
                                                                                <li key={`kept_${f?.id}`} className="d-flex align-items-center justify-content-between border rounded px-2 py-1 mb-1 text-xs">
                                                                                    <a href={f?.original} target="_blank" rel="noreferrer" className="text-truncate me-2">{f?.file_name_original || f?.file_name}</a>
                                                                                    <span className="d-flex align-items-center gap-2 flex-shrink-0">
                                                                                        <span className="text-muted">uploaded</span>
                                                                                        <button type="button" className="btn btn-sm btn-link text-danger p-0" title="Remove"
                                                                                            onClick={() => removeExistingFile(question?.id, f?.id, value, onChange)}>&times;</button>
                                                                                    </span>
                                                                                </li>
                                                                            ))}
                                                                            {newFiles.map((f: File, i: number) => (
                                                                                <li key={`new_${i}_${f.name}`} className="d-flex align-items-center justify-content-between border rounded px-2 py-1 mb-1 text-xs">
                                                                                    <span className="text-truncate me-2">{f.name}</span>
                                                                                    <span className="d-flex align-items-center gap-2 flex-shrink-0">
                                                                                        <span className="text-muted">{(f.size / 1024 / 1024).toFixed(1)} MB · new</span>
                                                                                        <button type="button" className="btn btn-sm btn-link text-danger p-0" title="Remove"
                                                                                            onClick={() => removeNewFile(question?.id, i, value, onChange)}>&times;</button>
                                                                                    </span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </>;
                                                            }}
                                                        />
                                                        <Error error={errors[`question_${question?.id}`]} customClass="text-xs" />
                                                        {AI_BTN(question)}
                                                    </div>
                                                } else if (question?.question_type?.type_name === 'textarea') {
                                                    return <div key={`textarea_${question.question_text}`} className="mb-3 float-input">
                                                        <label className="form-label">{question.question_text} <span>{getRequiredStart(question?.question_in_questionnaire_step?.validations)}</span></label>
                                                        <Controller
                                                            defaultValue={""}
                                                            control={control}
                                                            name={`question_${question?.id}`}
                                                            rules={getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text)}

                                                            render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                                <FormTexAreatInput
                                                                    name={name}
                                                                    onChange={onChange}
                                                                    onBlur={onBlur}
                                                                    value={value}
                                                                    inputRef={ref}
                                                                    type="text"
                                                                    rows={4}
                                                                />
                                                            )}
                                                        />
                                                        <Error error={errors[`question_${question?.id}`]} customClass="text-xs" />
                                                        {AI_BTN(question)}
                                                        {/* {
                                                            question?.prompt != null && <div className="btn-wrap-bp justify-content-end">
                                                                <button type="button" className="solid-btn get_ai_recommendations mt-2"
                                                                    id={`AI_btnId__${question?.id}`} onClick={() => getAIRecommendations(question?.id, question?.question_text)}
                                                                    disabled={aiBtnDisable}>
                                                                    {(aiBtnDisableId == question?.id) ? 'Generating AI Assistance...' : 'AI Assistance'}
                                                                </button>
                                                            </div>
                                                        } */}

                                                    </div>
                                                } else if (question?.question_type?.type_name === 'checkbox') {
                                                    return <div key={`checkbox_${question.question_text}`} className="accordion bp-accordion mb-3" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h2 className="accordion-header">
                                                                <button className="accordion-button px-3" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne_${question?.id}`} aria-expanded="true" aria-controls={`collapseOne_${question?.id}`}>
                                                                    {question.question_text} <span className='text-danger'>{getRequiredStart(question?.question_in_questionnaire_step?.validations)}</span>
                                                                </button>
                                                            </h2>
                                                            <div id={`collapseOne_${question?.id}`} className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                                <div className="accordion-body">
                                                                    <div className="check-wrap">
                                                                        {question?.options && question?.options.map((item: any) => (
                                                                            <label key={`checkbox__${item?.option_text}`} className="container-check me-5">
                                                                                {item?.option_text}
                                                                                <input type="checkbox" className="form-control" value={item?.id}
                                                                                    // defaultChecked={getValues()[`question_${question?.id}[option]`] == item?.id ? true : false}
                                                                                    defaultChecked={getValues()[`question_${question?.id}[option]`]?.includes(item?.id) ? true : false}
                                                                                    {...register(`question_${question?.id}[]`,
                                                                                        getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text)
                                                                                    )} />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        ))}
                                                                        <>
                                                                        {AI_BTN(question)}
                                                                        </>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Error error={errors[`question_${question?.id}`]} customClass="text-xs" />
                                                        </div>
                                                    </div>;
                                                } else if (question?.question_type?.type_name === 'radio' || question?.question_type?.type_name === 'dropdown') {
                                                    return <div key={`radio_${question.question_text}`} className="accordion bp-accordion mb-3" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h2 className="accordion-header">
                                                                <button className="accordion-button px-3" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne_${question?.id}`} aria-expanded="true" aria-controls={`collapseOne_${question?.id}`}>
                                                                    {question.question_text} <span className='text-danger'>{getRequiredStart(question?.question_in_questionnaire_step?.validations)}</span>
                                                                </button>
                                                            </h2>
                                                            <div id={`collapseOne_${question?.id}`} className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                                <div className="accordion-body">
                                                                    <div className="radio-wrap">
                                                                        {question?.options && question?.options.map((item: any) => (
                                                                            <label key={`radio__${item?.option_text}`} className="container-radio me-5">
                                                                                {item?.option_text}
                                                                                {
                                                                                    // getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text).required && <span className='text-danger'>*</span>
                                                                                }
                                                                                <input type="radio" className="form-control" value={item?.id}
                                                                                    defaultChecked={getValues()[`question_${question?.id}[option]`] == item?.id ? true : false}

                                                                                    {...register(`question_${question?.id}[option]`,
                                                                                        getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text)
                                                                                    )} />
                                                                                <span className="checkmark"></span>
                                                                            </label>
                                                                        ))}
                                                                        <>{AI_BTN(question)}</>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                (errors[`question_${question?.id}`]) && <p className="text-danger text-xs"><span>The field is required.</span></p>
                                                            }

                                                            {/* <Error error={errors[`question_${question?.id}`]} customClass="text-xs" /> */}
                                                        </div>

                                                    </div>;
                                                } else if (question?.question_type?.type_name === 'dropdown') {
                                                    let ansDropOptions: any = [];
                                                    question?.options && question?.options.map((item: any) => (
                                                        ansDropOptions.push({ value: item?.id, label: item?.option_text })
                                                    ))
                                                    return <div key={`radio_${question.question_text}`} className="accordion bp-accordion mb-3" id="accordionExample">
                                                        <div className="accordion-item">
                                                            <h2 className="accordion-header">
                                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne_${question?.id}`} aria-expanded="true" aria-controls={`collapseOne_${question?.id}`}>
                                                                    {question.question_text} <span className='text-red-500'>{getRequiredStart(question?.question_in_questionnaire_step?.validations)}</span>
                                                                </button>
                                                            </h2>
                                                            <div id={`collapseOne_${question?.id}`} className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                                <div className="accordion-body" style={{ minHeight: '100px' }}>
                                                                    <div className="radio-wrap">
                                                                        <Controller
                                                                            defaultValue={""}
                                                                            rules={getFieldValidations(question?.question_in_questionnaire_step?.validations, question.question_text)}
                                                                            control={control}
                                                                            name={`question_${question?.id}`}
                                                                            render={({
                                                                                field: { onChange, onBlur, value, name, ref },
                                                                            }) => (
                                                                                <Select
                                                                                    name={name}
                                                                                    onChange={onChange}
                                                                                    onBlur={onBlur}
                                                                                    options={ansDropOptions}
                                                                                    value={value}
                                                                                    placeholder="Select..."
                                                                                />
                                                                            )}
                                                                        />
                                                                        <>{AI_BTN(question)}</>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Error error={errors[`question_${question?.id}`]} customClass="text-xs" />
                                                        </div>




                                                    </div>
                                                }
                                            }) :

                                                <div className="text-center">
                                                    <p className="text-danger mb-5">No questionnaire added!</p>
                                                </div>
                                            }
                                        </div>


                                        <div className="btn-wrap-bp">
                                            {
                                                (tabIndex === 0) ? <Link to={_proId ? URLS.ACCOUNT.MY_BUSINESS_PLAN : URLS.SUBSCRIPTION + "?id=" + subsId}>
                                                    <button type="button" className="outline-btn">Back</button>
                                                </Link>
                                                    : <button type="button" className="outline-btn" onClick={() => { clearErrors(); setCurrentActiveTab(currentActiveTab - 1); }}>Back</button>
                                            }


                                            <button type="submit"
                                                // onClick={saveFormHandler}
                                                className="solid-btn">{(tabIndex + 1 === questionnaire.length) ? 'Finish' : 'Next'}</button>
                                        </div>
                                    </form>
                                </div>
                            )
                        }
                    })
                }
                {
                    questionnaire?.length == 0 &&
                    <div className="main-part-bp text-center">
                        <p className="text-danger mb-5">No questionnaire available!</p>
                        <Link to={URLS.SUBSCRIPTION} className="select_plan">Back to Subscriptions</Link>
                    </div>
                }
                {
                    questionnaire == null && <div className="main-part-bp text-center">
                        <p className="text-danger mb-5">Loading...</p> </div>
                }
            </div>
            
            {/* comment-out-since-it's-not-needed-currently */}
            {/* <AIAssistanceAnsRight show={showAiAns} handleClose={handleClose} AIData={AIDataRight} /> */}
            <HelpPanelRight show={showHelp} handleClose={handleHelpClose} helpData={helpDataRight} />

            {!isEmbed && <Footer />}




        </>
    )
}

export default BusinessPlan;